export default __webpack_public_path__ + "ui/assets/img/arrow-right-white-32.svg";